import { getProductBySku } from 'application/repositories/ecommerceRepository';
import { getPageContent } from 'application/repositories/pageContentRepository';
import { getNavigationData } from 'application/repositories/navigationRepository';
import logger from 'helpers/logger';
import { GetStaticProps, GetStaticPaths } from 'next';
import { getSignupFormData } from 'application/repositories/formRepository';
import { getLanguages } from 'application/repositories/languagesRepository';
import { getLocations } from 'application/repositories/locationsRepository';
import { ProductFeature } from 'features/Modules/Product/ProductFeature';

const Product = (props) => {
	logger.info('Rendering with ISR (incremental static regeneration)');
	return <ProductFeature {...props} />;
};

export default Product;

export const getStaticPaths: GetStaticPaths = async () => {
	return {
		paths: [],
		fallback: 'blocking',
	};
};

export const getStaticProps: GetStaticProps<any> = async ({ params, preview, previewData: untypedPreviewData, locale }) => {
	try {
		const { origin, slug } = params;

		const url = '';
		const host = atob(origin as string);

		const previewData = untypedPreviewData as Models.PreviewData;
		const content = await getPageContent({
			url,
			host,
			preview,
			previewData,
			locale,
		});
		const culture = locale === 'default' ? 'en' : locale;

		const countryCode = '';

		const navigationData = await getNavigationData({
			host: host,
			locale: culture,
		});

		const productId = slug[0];
		const product = await getProductBySku(productId, culture, countryCode);

		const signupFormData = await getSignupFormData({
			host,
			locale: culture,
		});

		const languageSelector = await getLanguages({
			host,
			locale: culture,
		});

		const locations = await getLocations({ host: host, locale: culture });
		return {
			props: {
				content,
				host,
				product,
				navigationData,
				signupFormData,
				languageSelector,
				locations,
				culture,
			},
			revalidate: 60,
		};
	} catch (err) {
		if (err?.statusCode === 301 || err?.statusCode === 302) {
			return {
				redirect: {
					statusCode: err.statusCode,
					destination: err.url,
				},
			};
		}

		if (err?.statusCode === 404 || err?.statusCode === 500) {
			return {
				notFound: true,
			};
		}

		logger.debug(err);

		throw new Error(err);
	}
};
